import { useEffect } from "react";

import { useDocumentTitle } from "@refinedev/react-router";

import { SiteForm } from "@/pages/tina/sites/components/site-form";

export const SitesCreate = () => {
  const setTitle = useDocumentTitle();

  useEffect(() => {
    setTitle("Add Instagram site | Tina");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex w-full max-w-6xl flex-col gap-4 p-8">
      <div>
        <h1 className="text-2xl font-semibold">Add Instagram site</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Create a music source from an Instagram profile. Other source kinds are
          not supported yet.
        </p>
      </div>
      <SiteForm />
    </div>
  );
};
